import { UI_AssetMap } from "../components/utils/imageMap";


export const gamesData = [
  {
    id: 1,
    title: "Kids Coloring Book",
    description:
      "Educational adventures for ages 2-6, ABC, 123 & preschool learning",
    rating: 4.9,
    downloads: "",
    preview: UI_AssetMap.ColoringBooKAppBanner_Img, // Add actual preview image imports
    ageRange: "Ages 2-6",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-coloring-app",

    appStore:
      "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    playStore:
      "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    icon: UI_AssetMap.ColoringBook_Icon,
    color: "from-green-500 to-yellow-400",
    features: ["ABC Learning", "Parent Dashboard", "Ad-Free"],
    videoTrailer: "trailer3.mp4",
  },
  {
    id: 2,
    title: "Toddler Learning Games",
    description:
      "Educational adventures for ages 2-6, ABC, 123 & preschool learning",
    rating: 4.9,
    downloads: "",
    preview: UI_AssetMap.KidsLearningBanner_Img, // Add actual preview image imports
    ageRange: "Ages 2-6",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-kidslearning-app",

    appStore:
      "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    playStore:
      "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    icon: UI_AssetMap.KidsLearning_Icon,
    color: "from-green-500 to-yellow-400",
    features: ["ABC Learning", "Parent Dashboard", "Ad-Free"],
    videoTrailer: "trailer3.mp4",
  },

  {
    id: 3,
    title: "Jigsaw Puzzle Games!",
    description: "10000+ challenging puzzles with daily updates",
    rating: 4.9,
    reviews: "(Out of 4K+ Ratings)",
    preview: UI_AssetMap.JigShowPuzzleBanner_Img, // Add actual preview image imports
    ageRange: "Ages ANY",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-jigsaw-puzzles-colletion-app",
    appStore: "https://apps.apple.com/us/app/jigsaw-puzzle-games/id1049229735",
    playStore: "",
    icon: UI_AssetMap.Jigsaw_Icon,
    color: "from-purple-600 to-pink-500",
    features: ["Daily Challenges", "4K Graphics", "Global Leaderboards"],
    videoTrailer: "trailer1.mp4",
  },
  {
    id: 4,
    title: "Baby Phone for kids",
    description:
      "Educational adventures for ages 2-6, ABC, 123 & preschool learning",
    rating: 4.9,
    downloads: "",
    preview: UI_AssetMap.BabyPhoneGameBanner_Img, // Add actual preview image imports
    ageRange: "Ages 2-6",
    awards: ["Teachers' Choice", "Parent Approved"],
    appStore:
      "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    url: "https://twepple.com/open-babyphone-app",
    playStore:
      "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    icon: UI_AssetMap.BabyPhone_Icon,
    color: "from-green-500 to-yellow-400",
    features: ["ABC Learning", "Parent Dashboard", "Ad-Free"],
    videoTrailer: "trailer3.mp4",
  },
  {
    id: 5,
    title: "Maths Games for Kids",
    description:
      "Educational adventures for ages 2-6, ABC, 123 & preschool learning",
    rating: 4.9,
    downloads: "",
    preview: UI_AssetMap.MathGameBanner_Img, // Add actual preview image imports
    ageRange: "Ages 2-6",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-math-app",
    appStore:
      "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    playStore:
      "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    icon: UI_AssetMap.MathGame_Icon,
    color: "from-green-500 to-yellow-400",
    features: ["ABC Learning", "Parent Dashboard", "Ad-Free"],
    videoTrailer: "trailer3.mp4",
  },
  {
    id: 6,
    title: "Baloon Pop for Kids",
    description:
      "Educational adventures for ages 2-6, ABC, 123 & preschool learning",
    rating: 4.9,
    downloads: "",
    preview: UI_AssetMap.BaloonPopGameBanner_Img, // Add actual preview image imports
    ageRange: "Ages 2-6",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-balloonpop-app",
    appStore:
      "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    playStore:
      "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    icon: UI_AssetMap.BaloonPop_Icon,
    color: "from-green-500 to-yellow-400",
    features: ["ABC Learning", "Parent Dashboard", "Ad-Free"],
    videoTrailer: "trailer3.mp4",
  },
  {
    id: 7,
    title: "Jigsaw  HD  Puzzles",
    description:
      "4K puzzles with magical themes, Up to 2500 pieces puzzle games",
    rating: 4.9,
    reviews: "(Out of 250+ Ratings)",
    preview: UI_AssetMap.JigShowHdPuzzleBanner_Img, // Add actual preview image imports
    ageRange: "Ages ANY",
    awards: ["Teachers' Choice", "Parent Approved"],
    url: "https://twepple.com/open-jigsaw-puzzle-app",

    appStore: "https://apps.apple.com/us/app/jigsaw-hd-puzzles/id1045849829",
    playStore: "",
    icon: UI_AssetMap.Jigsawhd_Icon,
    color: "from-blue-500 to-cyan-400",
    features: ["Magic Themes", "Relaxing Music", "Achievement System"],
    videoTrailer: "trailer2.mp4",
  },
];